import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Button} from "../../UI/Button";
import {Input} from "../../UI/Input";
import {ERRORS} from "../../Consts/Errors";
import {validationEmail, validationField, validationPassword} from "../../Global/Validation";
import {useDispatch} from "react-redux";
import {LoaderHide, LoaderShow} from "../../Store/Actions/Loader";
import Api from "../../API/api";
import {showToast} from "../../Store/Actions/ToastAction";

export const Words = () => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [words, setWords] = useState([])
  const [allData, setAllData] = useState({})
  const [wordId, setWordId] = useState(null)
  const [allowed, setAllowed] = useState(true)
  const [deleteModal, setDeleteModal] = useState(false)
  const [isAllowed, setIsAllowed] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [input, setInput] = useState({
    word: {
      id: "word",
      value: "",
      correct: false,
      error_text: ERRORS.word,
      error: false,
    },
    searchWord: {
      id: "searchWord",
      value: "",
      correct: false,
      error_text: ERRORS.word,
      error: false,
    }
  })

  useEffect(() => {
    setTimeout(() => {
      getWords()
    }, 450)
  }, [input.searchWord.value])

  useEffect(() => {
    getWords()
  }, [currentPage, isAllowed])



  useEffect(() => {
    setInput((old) => ({
      ...old,
      word: { ...old.word, correct: validationField(input.word.value), error: false },
    }));
  }, [input.word.value]);

  const getValue = (target) => {
    setCurrentPage(1)
    setInput((old) => ({
      ...old,
      [target.id]: {
        ...old[target.id],
        value: target.value.replace(/[^A-Za-z]/ig, ""),
      },
    }));
  };

  const addWord = () => {
    const endpoint = wordId ? `word/${wordId}` : 'word'
    const body = {
      word: input.word.value,
      isAllowed: allowed
    }
    if(input.word.value.length >= 3) {
      dispatch(LoaderShow())
      Api.postData(endpoint, body, localStorage.getItem('userToken'))
        .then(() => {
          dispatch(LoaderHide())
          getWords()
          setModal(false)
          setWordId(null)
          setAllowed(true)
          dispatch(showToast({
            title: "Words",
            text: wordId ? 'Word successfully edited' : 'Word successfully added',
            type: "success",
          }))
        })
        .catch(err => {
          dispatch(LoaderHide())
          dispatch(showToast({
            title: "Words",
            text: err.response.data.message,
            type: "error",
          }))
        })
    } else {
      setInput((old) => ({
        ...old,
        word: { ...old.word, error: true },
      }));
    }
  }

  const deleteWord = () => {
    dispatch(LoaderShow())
    Api.delete(`word/${wordId}`, {}, localStorage.getItem('userToken'))
      .then(() => {
        dispatch(LoaderHide())
        closeDeleteModal()
        getWords()
        setWordId(null)
        setAllowed(true)
        dispatch(showToast({
          title: "Words",
          text: 'Word successfully deleted',
          type: "success",
        }))
      })
      .catch(err => {
        dispatch(LoaderHide())
        dispatch(showToast({
          title: "Words",
          text: err.response.data,
          type: "error",
        }))
      })
  }

  const openDeleteModal = (id) => {
    setDeleteModal(true)
    setWordId(id)
  }

  const closeDeleteModal = () => {
    setDeleteModal(false)
    setWordId('')
  }

  const openModal = () => {
    setModal(true)
    setInput((old) => ({
      ...old,
      word: { ...old.word, value: '' },
    }));
  }

  const getWords = () => {
    dispatch(LoaderShow())
    Api.getData(`word?page=${currentPage}&perPage=10${input.searchWord.value ? '&word=' + input.searchWord.value : ''}&isAllowed=${isAllowed}`, localStorage.getItem('userToken'))
      .then(res => {
        if (currentPage === 1) {
          setWords(res.data.words)
        } else {
          setWords(prevState => ([...prevState, ...res.data.words]))
        }
        setAllData(res.data)
        dispatch(LoaderHide())
      })
      .catch(() => {
        dispatch(LoaderHide())
      })
  }

  const changeAllowed = (e) => {
    setAllowed(e.target.checked)
  }

  const renderWords = () => {
    return words?.map(item => (
      <div className="avatars__list-item">
        <p>{item?.word}</p>
        <div className="avatars__list-btns">
          <div onClick={() => {
            setWordId(item.id)
            setInput((old) => ({
              ...old,
              word: { ...old.word, value: item.word },
            }));
            setAllowed(item.isAllowed)
            setModal(true)
          }} className="avatars__list-btn"><img src="/assets/icons/edit.svg" alt="edit"/></div>
          <div onClick={() => {openDeleteModal(item.id)}} className="avatars__list-btn"><img src="/assets/icons/trash.svg" alt="trash"/></div>
        </div>
      </div>
    ))
  }

  const nextPage = () => setCurrentPage(prevState => prevState + 1)

  return (
    <>
      {deleteModal && (<div className="modal">
        <div className="modal__content words__modal">
          <div className="words__modal-head">
            <p className="words__modal-title">Delete Word</p>
            <p className="words__modal-text">You are going to delete this word, are you sure?</p>
            <div onClick={() => {
              closeDeleteModal()
            }} className="modal__close"><img src="/assets/icons/close.svg" alt=""/></div>
          </div>
          <div className="modal__btns">
            <div className="words__modal-btn">
              <Button text="Cancel" type={'gray'} action={closeDeleteModal} />
            </div>
            <div className="words__modal-btn">
              <Button text="Delete" action={deleteWord} />
            </div>
          </div>
        </div>
        <div onClick={
          () => {
            closeDeleteModal()
          }} className="modal__bg"></div>
      </div>)}
      {modal && (<div className="modal">
        <div className="modal__content words__modal">
          <div className="words__modal-head">
            <p className="words__modal-title">{wordId ? 'Edit' : 'Add'} Word</p>
            <div onClick={() => {
              setModal(false)
              setWordId(null)
              setAllowed(true)
            }} className="modal__close"><img src="/assets/icons/close.svg" alt=""/></div>
          </div>
          <div className="words__modal-input">
            <Input
              placeholder={"Enter word"}
              type="text"
              id={input.word.id}
              value={input.word.value}
              error_text={input.word.error_text}
              error={input.word.error}
              correct={input.word.correct}
              max_length="5"
              getValue={getValue}
            />
          </div>
          <label className="allowed" htmlFor="allowed">Allowed</label>
          <input defaultChecked={allowed} onChange={(e) => {changeAllowed(e)}} id='allowed' type="checkbox"/>
          <div className="words__modal-btn">
            <Button text="Save" action={addWord} />
          </div>
        </div>
        <div onClick={
          () => {
            setModal(false)
            setWordId(null)
            setAllowed(true)
          }} className="modal__bg"></div>
      </div>)}
      <div className='page'>
        <Helmet>
          <meta charSet="utf-8"/>
          <title>SARK ADMIN | WORDS</title>
        </Helmet>
        <div className="words container">
          <div className="avatars__head">
            <p className="users__title">Words <span>Total: {allData.total} word(s)</span></p>
            <div className="words__btn">
              <Button text={'Add word'} action={openModal}/>
            </div>
          </div>
          <div className="words__search">
            <Input
                placeholder={"Search word"}
                type="text"
                id={input.searchWord.id}
                value={input.searchWord.value}
                error_text={input.searchWord.error_text}
                correct={input.searchWord.correct}
                error={input.searchWord.error}
                max_length="5"
                getValue={getValue}
            />
            <div className="words__search-separator"></div>
            <div className="words__search-isAllowed">
              <label htmlFor="isAllowed">Is Allowed
                <input type="checkbox" id="isAllowed" defaultChecked={isAllowed} onChange={(e) => setIsAllowed(e.target.checked)} />
                <span className="checkmark"></span>
              </label>

            </div>
          </div>
          <div className="words__list">
            {renderWords()}
          </div>
          {
            words.length > 0 && currentPage !== allData.totalPage &&
            <div className="words__more">
              <p onClick={nextPage}>Load more</p>
            </div>
          }

        </div>
      </div></>
  )
}
